import styled from 'styled-components/macro';
import { FlexWrapper } from '@yme/tokens/flexTokens';
export const SectionStyled = styled(FlexWrapper) `
  &:last-child {
    padding-bottom: 0;
  }
`;
